/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <PrixMinus {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section, CmsImage } from "@bw/bits"
import { PrixMinusMap as PrixMinusModule } from "@bw/modules"

const Minus = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  minus,
  anchor,
}) => {
  if (!minus || minus.length === 0) {
    return null
  }
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        minus,
        anchor,
      }}
    >
      <PrixMinusModule
        contents={minus.map(item => ({
          ...item,
          excerpt: item.subtitle,
          price: item.finalePrice,
          href: item.abilisUrl,
          image: <CmsImage src={item.image} alt={item.title} />,
          legal: item.legal,
          titular: item.titular,
        }))}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on MinusModule {
 *   ...MinusModuleFragment
 * }
 *
 * This is also what you will get in the props of your PrixMinus
 * resolver component.
 */
export const query = graphql`
  fragment MinusModuleFragment on MinusModule {
    minus {
      title
      subtitle
      image {
        localImage {
          childImageSharp {
            gatsbyImageData(width: 174)
          }
        }
      }
      finalePrice
      discount
      abilisUrl
      legal
      titular
    }
  }
`

export { Minus }
